export function isAdminProfile(profile) {
  if (!profile) return false;
  const normalized = profile.toUpperCase();
  return normalized === "ADMIN" || normalized === "SUPERADMIN";
}
